<template>
  <a-popover v-model="visible" trigger="click">
    <template #content>
      <div style="display: flex">
        <a-icon type="question-circle-o" style="color: red;padding: 4px;"/>
        <div>
          <p>供应商名称：{{ item.supplierName }}</p>
          <p>信用代码（税号）：{{ item.supplierCode }}</p>
          <p>项目名称：{{ item.projectName }}</p>
          <p>项目编号：{{ item.projectCode }}</p>
        </div>
      </div>

      <div style="text-align: right">
        <a-space>
          <a-button size="small">
            取消
          </a-button>
          <a-button type="primary" size="small" @click="onEditKp">
            {{ kpzt.okText }}
          </a-button>
          <a-button v-if="item.kpzt === '0'" :loading="loading" type="primary" size="small" @click="invoice">
            电子开票
          </a-button>
        </a-space>
      </div>
    </template>
    <a class="ml-1 mr-1" :style="{color:kpzt.color}">{{ kpzt.text }}</a>
  </a-popover>
</template>

<script>
import qs from 'qs'

export default {
  name: 'InvoicePopConfirm',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      visible: false,
      loading: false
    }
  },
  computed: {
    kpzt () {
      if (this.item && this.item.kpzt === '1') {
        return {
          color: 'red',
          okText: '确认未开票',
          text: '已开票'
        }
      } else {
        return {
          color: '',
          okText: '已线下开票',
          text: '未开票'
        }
      }
    }
  },
  methods: {
    onEditKp () {
      const { id, kpzt } = this.item
      const data = {
        attendOrderId: id,
        kpzt: kpzt === '0' ? '1' : '0'
      }
      this.$http.post('/api/1/signSupplier/setAttendKp.json', qs.stringify(data)).then((response) => {
        if (response.code !== 200) {
          this.$message.error('更新开票状态失败')
        }
        this.$emit('refresh')
      })
    },
    async invoice () {
      this.visible = false
      const h = this.$createElement
      const { id, supplierName, projectName } = this.item
      this.$confirm({
        title: '确认开票？',
        content: h('div', {}, [
          h('div', `供应商名称：${supplierName}`),
          h('div', `项目名称：${projectName}`)
        ]),
        onOk: async () => {
          this.loading = true
          const data = {
            orderId: id,
            attendId: this.item.attendId
          }
          // 按项目购标需要用另一个接口
          const api = data.attendId
              ? '/api/1/signSupplier/invoice_by_order_id_and_attend_id.json'
              : '/api/1/signSupplier/invoice_by_order_id.json'
          const res = await this.$http.post(api, qs.stringify(data))
          this.loading = false
          this.$emit('refresh')
          if (res.code === 200) {
            this.$message.success('电子开票成功')
          } else {
            this.$message.error('电子开票失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
